export default [
  {
    path: '/fafuli/',
    component: () => {
      return import(
        /* webpackChunkName: "fafuli" */ '@/views/fafuli/layout.vue'
      )
    },
    children: [
      {
        path: 'detail',
        name: 'fafuli-detail',
        component: () => {
          return import(
            /* webpackChunkName: "fafuli" */ '@/views/fafuli/detail.vue'
          )
        }
      },
      {
        path: 'upload',
        name: 'fafuli-upload',
        component: () => {
          return import(
            /* webpackChunkName: "fafuli" */ '@/views/fafuli/upload.vue'
          )
        }
      },
      {
        path: 'uploadList',
        name: 'fafuli-uploadList',
        component: () => {
          return import(
            /* webpackChunkName: "fafuli" */ '@/views/fafuli/uploadList.vue'
          )
        }
      },
      {
        path: 'result',
        name: 'fafuli-result',
        component: () => {
          return import(
            /* webpackChunkName: "fafuli" */ '@/views/fafuli/result.vue'
          )
        }
      },
      {
        path: 'claimNotice',
        name: 'fafuli-claim-notice',
        component: () => {
          return import(
            /* webpackChunkName: "fafuli" */ '@/views/fafuli/claimNotice.vue'
          )
        }
      }
    ]
  }
]
